export enum AlertProvidersActionTypes {
  UPDATED = 'alert-providers/UPDATED',
  UPDATING = 'alert-providers/UPDATING',
}
